import PropTypes from 'prop-types';

export const OptionDataPropType = PropTypes.shape({
  packageTypeId: PropTypes.string,
  serviceId: PropTypes.string,
  labelProviderId: PropTypes.string,
});

export const DefaultOptionData = {
  packageTypeId: '',
  serviceId: '',
  labelProviderId: '',
};
